<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";
import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
        InputGroup,
        SelectGroup
    },
    data() {
        return {
            title: "Staffs",
            items: [
                {
                    text: "Staffs"
                },
            ],
            filter: {
                name: '',
                branch: ''
            },
            fields: [
                { key: "action" },
                { key: 'id', sortable: true, label: 'Staff ID' },
                { key: "name", sortable: true, label: 'Name' },
                { key: "phone", sortable: true, label: 'Phone' },
                { key: "status", sortable: true, label: "Status" },
                { key: "branch", sortable: true, label: "Branch" },
                { key: "recurring_days", sortable: true, label: "Recurring Block Set" },
            ],
            branchOptions: [],
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });
    },
    methods: {
        async retrieveBranches() {
            this.loading = true;
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    branches = result['data'].branches;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return branches;
        },

        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/staff/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete staff (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        },

        resetTable() {
            this.filter = {
                name: '',
                branch: '',
            };

            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2 ml-0">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Staff Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Staff</router-link>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <InputGroup id="search" type="text" displayName="Search" v-model="filter.name" :onEnter="filterTable" />
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3 mt-2">
                                <SelectGroup id="branch" displayName="Branch" v-model="filter.branch" :options="branchOptions" />
                            </div>
                            <div class="col-12">
                                <a href="javascript:void(0);" class="btn btn-success mt-2" @click="filterTable">
                                    Filter
                                </a>
                                <a href="javascript:void(0);" class="btn btn-danger ml-3 mt-2" @click="resetTable">
                                    Reset
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pl-4 pr-4">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="staff" listName="staffs">
                            <template v-slot:cell(status)="row">
                                <div class="badge font-size-12" :class="{
                                    'badge-soft-danger': row.value == 0,
                                    'badge-soft-success': row.value == 1,
                                }">{{ row.value == 1 ? 'Active' : 'Inactive' }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Staff Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>